import {
  observable,
  action,
  decorate,
} from 'mobx';

class ReportStore {
  constructor(api, snackbarStore, loadingStore) {
    this.api = api;
    this.snackbarStore = snackbarStore;
    this.loadingStore = loadingStore;
    this.reports = null;
  }

  setReports(reports) {
    this.reports = reports;
  }

  get getReports() {
    return this.reports;
  }

  async fetch() {
    try {
      const response = await this.api.reports.get();
      if (response) {
        this.setReports(response);
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    } catch (e) {
      e.error = true;
      return Promise.reject(e);
    }
  }

  async create(payload) {
    this.loadingStore.setReady(false);
    try {
      await this.api.reports.create(payload);

      this.snackbarStore.setSuccess({
        title: 'Report has been successfully created.',
      });
      this.loadingStore.setReady(true);

      return Promise.resolve(true);
    } catch (e) {
      e.error = true;
      this.snackbarStore.setError({
        title: `Sorry, an error occurred.${e.errors ? ' Please correct the errors below:' : ''}`,
        duration: null,
        messages: e.errors ? e.errors : null,
      });
      this.loadingStore.setReady(true);
      return Promise.reject(e);
    }
  }
}

decorate(ReportStore, {
  reports: observable,
  setReports: action,
});

export default ReportStore;



// WEBPACK FOOTER //
// ./src/stores/report.js